import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ConfigProvider } from '../config/config';
import { CorsHttpProvider } from '../providers/http/http';



export class TrustMcpUrl implements PipeTransform {
  constructor(private config: ConfigProvider, private http: CorsHttpProvider) { }

  transform(value: string, ..._args: any[]): any {
    if (!value) {
      return null;
    }

    const params: string = [
      '__cors-request__=true',
      '__app-key__=' + this.config.get().login.appKey,
      '__dev-mode__=' + this.config.get().devMode,
      '__ticket__=' + this.http.ticket
    ].join('&');

    if (value.indexOf('?') === -1) {
      return value + '?' + params;
    }
    return value + '&' + params;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'trustMcpUrl',
  pure: true
}, ] },
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConfigProvider, },
{type: CorsHttpProvider, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
